module.exports = __webpack_public_path__ + "img/nav-logo.335f7405.webp";